module.exports = __webpack_public_path__ + "static/car-pc/img/avatar-default.ec18b959.png";